import { render } from "./Sidebar.vue?vue&type=template&id=3d4db668&bindings={}"
import script from "./Sidebar.vue?vue&type=script&lang=ts"
export * from "./Sidebar.vue?vue&type=script&lang=ts"

import "./Sidebar.vue?vue&type=style&index=0&lang=scss"
script.render = render

export default script